import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { useLanguage } from "@/LanguageContext";
import { t } from "@/translations";

/**
 * Breadcrumb navigation component with Schema.org markup.
 * @param {Array} items - [{label: string, translationKey?: string, to?: string}]
 */
const Breadcrumbs = ({ items }) => {
  const { lang } = useLanguage();

  if (!items || items.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1.5 text-sm text-[#64748B] mb-4 flex-wrap"
      data-testid="breadcrumbs"
    >
      <Link
        to="/"
        className="hover:text-[#14B8A6] transition-colors flex items-center gap-1"
        data-testid="breadcrumb-home"
      >
        <Home size={14} />
        <span>{lang === "es" ? "Inicio" : "Home"}</span>
      </Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight size={14} className="text-[#94A3B8]" />
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-[#14B8A6] transition-colors"
              data-testid={`breadcrumb-${i}`}
            >
              {item.translationKey ? t(item.translationKey, lang) : item.label}
            </Link>
          ) : (
            <span className="text-[#0F172A] font-medium" data-testid={`breadcrumb-${i}`}>
              {item.translationKey ? t(item.translationKey, lang) : item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
